"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "app-mediaviewer"
  }, [_c('div', {
    staticClass: "app-mediaviewer-controls"
  }, [_vm.showPin ? _c('a', {
    staticClass: "u-button u-link app-mediaviewer-controls-pin",
    on: {
      "click": function ($event) {
        return _vm.$emit('pin');
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-map-pin",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _c('a', {
    staticClass: "u-button u-button-warning app-mediaviewer-controls-close",
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _c('div', {
    staticClass: "app-mediaviewer-content"
  }, [_vm.isIframe ? _c('iframe', {
    ref: "iframe",
    staticClass: "app-mediaviewer-iframe",
    attrs: {
      "src": _vm.url,
      "sandbox": _vm.iframeSandboxOptions
    }
  }) : _vm.component ? _c(_vm.component, _vm._b({
    tag: "component",
    attrs: {
      "component-props": _vm.componentProps
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      },
      "setHeight": _vm.setHeight,
      "setMaxHeight": _vm.setMaxHeight
    }
  }, 'component', _vm.componentProps, false)) : _c('url-embed', {
    attrs: {
      "url": _vm.url,
      "show-pin": _vm.showPin,
      "iframe-sandbox-options": _vm.iframeSandboxOptions
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      },
      "setHeight": _vm.setHeight,
      "setMaxHeight": _vm.setMaxHeight
    }
  })], 1)]);
};
var staticRenderFns = exports.staticRenderFns = [];